import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchNotifications,
  markAsRead,
  markAllRead,
  selectNotifications,
  selectUnreadCount,
} from "../redux/slices/notificationSlice";

const useNotifications = () => {
  const dispatch = useDispatch();

  const notifications = useSelector(selectNotifications);
  const unreadCount = useSelector(selectUnreadCount);

  const load = useCallback(
    (params) => dispatch(fetchNotifications(params)),
    [dispatch],
  );
  const read = useCallback((id) => dispatch(markAsRead(id)), [dispatch]);
  const readAll = useCallback(() => dispatch(markAllRead()), [dispatch]);

  return { notifications, unreadCount, load, read, readAll };
};

export default useNotifications;
